export default __webpack_public_path__ + "media/images/gallery/left-menu-bg-3c888a10ca2369bd3c89ad5fb291527b.jpg";